// extracted by mini-css-extract-plugin
export default {"ctn":"notes_ctn__WHbXJ"};